import React from "react";

/**
 * Shared visual chrome for ABGN-UK governance policies. Each policy page
 * supplies an icon, eyebrow, title, intro paragraph, and a list of sections
 * (with bullet items). Keeps policy pages visually consistent and quick to
 * update.
 */
export default function PolicyShell({ icon: Icon, eyebrow, title, intro, sections = [], approvedNote }) {
  return (
    <div className="bg-pearl">
      <section className="bg-navy text-pearl">
        <div className="section-container py-16">
          {Icon && (
            <div className="inline-flex items-center justify-center w-14 h-14 rounded-sm bg-saffron/15 border border-saffron/40 text-saffron mb-6">
              <Icon size={24} />
            </div>
          )}
          {eyebrow && <p className="eyebrow text-saffron">{eyebrow}</p>}
          <h1 className="mt-3 font-display text-4xl sm:text-5xl">{title}</h1>
          {intro && <p className="mt-5 text-pearl/80 max-w-3xl leading-relaxed">{intro}</p>}
        </div>
      </section>
      <section className="py-16">
        <div className="section-container max-w-4xl">
          {sections.map((sec) => (
            <div key={sec.title} className="mt-10 first:mt-0">
              <h2 className="font-display text-2xl sm:text-3xl text-navy">{sec.title}</h2>
              <ul className="mt-5 space-y-3 text-slate-700" data-testid={`policy-section-${sec.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
                {sec.items.map((it, i) => (
                  <li key={i} className="flex items-start gap-3 border-l-2 border-saffron/40 pl-4 py-1 leading-relaxed">
                    <span className="font-display text-saffron mt-0.5">•</span>
                    <span>{it}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
          {approvedNote && (
            <p className="mt-12 text-xs text-slate-500 italic">{approvedNote}</p>
          )}
        </div>
      </section>
    </div>
  );
}
